<template>
	<GridRowLabel label="SIMILAR" class="buybox-row">
		<GridPromotionSwiper
			:items="promotionItems"
			:title="title"
			:offers="[]"
			:additionalContexts="additionalContexts"
			:isPromoted="false"
		>
			<template #default="{ item, index }">
				<GridSQTV
					v-if="item.type === 'sqtv'"
					:catalogueItem="catalogueItem"
					:title="title"
					:additionalContexts="additionalContexts"
					:swiperIndex="index"
					:displayPromotedTag="false"
					:providerShortName="item.shortName"
					:isGreyCTA="true"
					:isSwiper="true"
				/>
				<GridQTV
					v-if="item.type === 'qtv'"
					:catalogueItem="catalogueItem"
					:title="title"
					:additionalContexts="additionalContexts"
					:swiperIndex="index"
					:displayPromotedTag="false"
					:hardcodedShortName="item.shortName"
				/>
				<GridSwiperFreeTrial
					v-if="item.type === 'ft'"
					:catalogueItem="catalogueItem"
					:title="title"
					:additionalContexts="additionalContexts"
					:swiperIndex="index"
					:displayPromotedTag="false"
					:hardcodedShortName="item.shortName"
				/>
			</template>
		</GridPromotionSwiper>
	</GridRowLabel>
</template>

<script setup lang="ts">
import { TitleDetail } from '@/interfaces/title-details-graphql';
import { SnowplowContext } from '@/helpers/tracking/providers';
import type { CatalogueItem } from '@/helpers/promotion-helper';

import GridRowLabel from '@/features/buybox/components/grid/GridRowLabel.vue';
import GridPromotionSwiper from '@/components/experiments/GridSwiperExp/components/GridPromotionSwiper.vue';
import { useGridSwiperExp } from '@/components/experiments/GridSwiperExp';

const GridSQTV = defineAsyncComponent(() => import('@/features/buybox/components/grid/GridSQTV.vue'));
const GridQTV = defineAsyncComponent(() => import('@/components/experiments/GridSwiperExp/GridQTV.vue'));
const GridSwiperFreeTrial = defineAsyncComponent(
	() => import('@/components/experiments/GridSwiperExp/GridSwiperFreeTrial.vue')
);

defineProps<{
	title: TitleDetail;
	providerShortName?: string | null;
	catalogueItem: CatalogueItem | null;
	additionalContexts?: SnowplowContext[];
}>();

const { promotionItems } = useGridSwiperExp();
</script>

<style scoped lang="scss">
.buybox-row {
	background: #ffffff0a;
}
// No additional styles needed for now
</style>
